/**
 * Management → Application Setting。
 * 打开页面打 STATSIG.COMMON.VIEW，value=mgmt_application_setting。
 *
 * 正在用：
 * - Enable Lender Loan Information(L1–L4)
 * - Enable Disposition Notification
 * - Download sample L1–L4 form (PDF)
 */
export enum MgmtAppSettingEvent {
    /**
     * 开关 Enable Lender Loan Information(L1–L4)。
     * 属性 enabled=true|false
     */
    LENDER_LOAN_INFO_SWITCH = 'APP_SETTING_LENDER_LOAN_INFO_SWITCH',
    /**
     * 开关 Enable Disposition Notification。
     * 属性 enabled=true|false
     */
    DISPOSITION_NOTIFICATION_SWITCH = 'APP_SETTING_DISPOSITION_NOTIFICATION_SWITCH',
    /** Download sample L1–L4 form (PDF) */
    DOWNLOAD_SAMPLE_L1_L4 = 'APP_SETTING_DOWNLOAD_SAMPLE_L1_L4',
}
